import React from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";

import { PageLayout } from "../../layouts/PageLayout";
import { AddEditAdminForm } from "../../components/superadmin";
import { PageHeader } from "../../components/v3";

export const AddEditAdmin = () => {
  const { id, adminId } = useParams();

  return (
    <PageLayout>
      {/* header section */}
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader
          // title
          title={adminId ? "Edit Admin" : "Add Admin"}
        />
      </Box>

      <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
        <AddEditAdminForm adminId={adminId} companyId={Number(id)} />
      </Box>
    </PageLayout>
  );
};
